import customfn from "@/_functions.js";

$(function () {

    var modal_id = '.create-inventorygroup ';

    $(document).on('click', '#add-inventory-group', function(ev){
        ev.preventDefault();
        // Get the modal
        var url = '/centre/inventorygroups/create';
        customfn.getModal(url);
    })

    // If the next button is clicked, get the form fields and post ti.
    $(document).on('click', modal_id + ' button.save-inventory-group', function(ev){
        ev.preventDefault();
        var form = $(this).closest('.modal').find('form'),
            formFields = form.serialize(),
            url = form.attr('action');
        customfn.postModal(url, formFields);
    });

    // Show or hide the other inventory
    $(document).on('click', 'a.inventory-show-all', function(ev){
        ev.preventDefault();
        // Get the first inventory_more
        // Check if this one got the class 'hide'

        if($(this).closest('div').prev().find('tr.inventory_more:first').hasClass('d-none')){
            $(this).closest('div').prev().find('tr.inventory_more').removeClass('d-none').animate('fast');
            // Set the text of the a
            $(this).find('.updowntext').text($(this).data('show-less-text'));
            // Set the arrow
            $(this).find('i.fa').removeClass('fa-arrow-down').addClass('fa-arrow-up');
        }
        else{
            $(this).closest('div').prev().find('tr.inventory_more').addClass('d-none').animate('fast');
            // Set the more text
            $(this).find('.updowntext').text($(this).data('show-more-text'));

            // Set the arrow
            $(this).find('i.fa').removeClass('fa-arrow-up').addClass('fa-arrow-down');
        }
    })

    // edit the inventory groups inventory
    $(document).on('click', '.edit-inventory-spaces', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        customfn.getModal(url);
    });

    // Save the groups
    // If the next button is clicked, get the form fields and post ti.
    $(document).on('click', '.select-inventory button.save-inventory', function(ev){
        ev.preventDefault();
        var form = $(this).closest('.modal').find('form'),
            formFields = form.serialize(),
            url = form.attr('action');
        customfn.postModal(url, formFields);
    });


    // Select all button for checkboxes view / select-wrapper
    $(document).on('click', '.select-all-btn', function(ev){
        ev.preventDefault();
        $(this).addClass('inactiveLink');

        var form = $(this).closest('.form-group');
        if(form.find('.checkboxes').length > 0) {
            form.find('.checkboxes .checkbox input[type=checkbox], .form-check-input').attr('checked', 'checked').prop('checked', true);
        }
        else if(form.find('.select-wrapper').length > 0) {
            form.find('.select-wrapper select option').attr('selected','selected').prop('selected', true);
            form.find('.select-wrapper select').trigger("chosen:updated");
        }
        form.find('.select-none-btn').removeClass('inactiveLink');
    });
    // Select none button for checkboxes view / select-wrapper
    $(document).on('click', '.select-none-btn', function(ev){
        ev.preventDefault();
        $(this).addClass('inactiveLink');

        var form = $(this).closest('.form-group');

        if(form.find('.checkboxes').length > 0) {
            form.find('.checkboxes .checkbox input[type=checkbox], .form-check-input').attr('checked', 'checked').prop('checked', false);
        }
        else if(form.find('.select-wrapper').length > 0) {
            form.find('.select-wrapper select option').removeAttr('selected').prop('selected', false);
            form.find('.select-wrapper select').trigger("chosen:updated");
        }
        form.find('.select-all-btn').removeClass('inactiveLink');
    });

    // Check for select all / none status based on checkboxes / options selected
    $(document).on('change', '.checkboxes .checkbox input[type="checkbox"], .select-wrapper select', function(){
        var form = $(this).closest('.form-group'),
            selectAll = form.find('.select-all-btn'),
            selectNone = form.find('.select-none-btn'),
            checkboxes = $(this).closest('.checkboxes'),
            select = $(this).closest('.select-wrapper');

        if(checkboxes.length > 0) {
            var all = checkboxes.find('.checkbox input[type="checkbox"]'),
                selected = checkboxes.find('.checkbox input[type="checkbox"]:checked');
        } else if(select.length > 0) {
            var all = select.find('select option'),
                selected = select.find('select option:selected');
        }

        if(selectAll.length > 0 && selected.length < all.length) {
            selectAll.removeClass('inactiveLink');
        } else if(selectAll.length > 0 && selected.length >= all.length) {
            selectAll.addClass('inactiveLink');
        }

        if(selectNone.length > 0 && selected.length > 0) {
            selectNone.removeClass('inactiveLink');
        } else if(selectNone.length > 0 && selected.length <= 0) {
            selectNone.addClass('inactiveLink');
        }
    });
});
